module.exports = __webpack_public_path__ + "img/Yogurt-Nan.067abd8a.jpg";